import { render, staticRenderFns } from "./HistorialEdicion.vue?vue&type=template&id=5be451be&"
import script from "./HistorialEdicion.vue?vue&type=script&lang=js&"
export * from "./HistorialEdicion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports